var OwnershipClientType = {
    Owner:1,
    Manager:2
};

export default OwnershipClientType;
